import React, {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Counts() {
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    useEffect(() => {
        const counters = document.querySelectorAll('.purecounter');
        counters.forEach(counter => {
          const startValue = parseInt(counter.getAttribute('data-purecounter-start'));
          const endValue = parseInt(counter.getAttribute('data-purecounter-end'));
          const duration = parseInt(counter.getAttribute('data-purecounter-duration'));
    
          animateCounter(counter, startValue, endValue, duration);
        });
    }, []);

    const animateCounter = (counter, start, end, duration) => {
      const increment = Math.floor((end - start) / duration);
      let startTime = null;

      const updateCounter = (timestamp) => {
        if (!startTime) {
          startTime = timestamp;
        }
    
        const elapsedTime = timestamp - startTime;
        if (elapsedTime >= duration * 500) {
          counter.innerText = end;
          return;
        }
    
        const value = Math.min(start + increment * (elapsedTime / (duration * 1000)), end);
        counter.innerText = Math.floor(value);
        requestAnimationFrame(updateCounter);
      };
    
      requestAnimationFrame(updateCounter);
    };
  return (
    <>
        <section id="counts" className="counts">
            <div className="container" data-aos="fade-up">
                <div className="row">
                    <div className="col-lg-3 col-md-6">
                        <div className="count-box">
                            <i className="bi bi-emoji-smile"></i>
                            <span data-purecounter-start="0" data-purecounter-end="300+" data-purecounter-duration="1" className="purecounter" data-toggle="counter-up">300+</span>
                            <p>Happy Clients</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mt-5 mt-md-0">
                        <div className="count-box">
                            <i className="bi bi-folder-fill"></i>
                            <span data-purecounter-start="0" data-purecounter-end="51+" data-purecounter-duration="1" className="purecounter" data-toggle="counter-up">51+</span>
                            <p>Projects</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                        <div className="count-box">
                            <i className="bi bi-telephone-inbound-fill"></i>
                            <span data-purecounter-start="0" data-purecounter-end="1463+" data-purecounter-duration="1" className="purecounter" data-toggle="counter-up">1,463+</span>
                            <p>Hours Of Support</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 mt-5 mt-lg-0">
                        <div className="count-box">
                            <i className="bi bi-person-circle"></i>
                            <span data-purecounter-start="0" data-purecounter-end="7" data-purecounter-duration="1" className="purecounter" data-toggle="counter-up">7</span>
                            <p>Hard Workers</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
